/* eslint-disable array-callback-return */
import React, { useContext, useEffect, createContext, useState } from "react"
import { autoRefresh } from '../../app/pages/auth/redux/AuthCRUD'
import { RootState } from '..'
import * as auth from '../../app/pages/auth/redux/AuthRedux'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { UserModel } from "../../app/pages/auth/models/UserModel"
import { useHistory } from "react-router-dom"

const Context = createContext<any>({})

export function useAuth() {
    return useContext(Context)
}

export function AuthProvider({ children }: any) {
    const dispatch = useDispatch()
    const history = useHistory();
    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const saltid = user?.saltid;
    const salt = user?.salt;
    const systemid = user?.systemid;
    const userid = user?.id;
    const sessionId = user?.sessionId;

    const [erp, setErp] = useState<string>("");
    const [partner, setPartner] = useState<string>("");
    const [customer, setCustomer] = useState<string>("");
    const [cloud, setCloud] = useState<boolean>(false);
    const [solo, setSolo] = useState<boolean>(false);
    const [enterprise, setEnterprise] = useState<boolean>(false);
    const [partnerCheck, setPartnerCheck] = useState<boolean>(false);

    const [currentStep, setCurrentStep] = useState<number>(0);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [maxIndex, setMaxIndex] = useState<number>(0);
    const [newCount, setNewCount] = useState<number>(0);
    const [showCompany, setShowCompany] = useState<boolean>(false);

    const [changed, setGlobalHasChanged] = useState<boolean>(false);
    const [savingProcesses, setSavingProcesses] = useState<any[]>([]);
    const [globalSaving, setGlobalSaving] = useState<boolean>(false);

    const [requestSqlVersion, setRequestSqlVersion] = useState<boolean>(false);
    const [requestXmlVersion, setRequestXmlVersion] = useState<boolean>(false);
    const [applySqlUpdates, setApplySqlUpdates] = useState<boolean>(false);
    const [applyXmlUpdates, setApplyXmlUpdates] = useState<boolean>(false);
    const [applyAllScripts, setApplyAllScripts] = useState<boolean>(false);
    const [applingSystem, setApplingSystem] = useState<any>(null);
    const [applingScriptName, setApplyingScriptName] = useState<string>("");

    const handleAddProcess = (process: string) => {
        setSavingProcesses((data: any) => [
            ...data,
            process
        ])
    }

    const handleRemoveProcess = (process: string) => {
        const newprocess = savingProcesses.filter((item: any) => item !== process);
        setSavingProcesses([...newprocess]);
    }

    const handleCurrentStep = (step: number) =>{
        setCurrentStep(step);
    }
    const handleCurrentIndex = (step: number) =>{
        setCurrentIndex(step);
    }
    const handleMaxIndex = (step: number) =>{
        setMaxIndex(step);
    }
    const handleNewCount = (step: number) =>{
        setNewCount(step);
    }
    const handleShowCompany = (flag: boolean) =>{
        setShowCompany(flag);
    } 

    const refresh = () => {
        try {
            if (sessionId) {
                const body = { salt, saltid, userid, systemid, sessionId };
                autoRefresh(body)
                    .then((res: any) => {
                        let { data } = res;
                        if (!data.sessionStatus) {
                            dispatch(auth.actions.logout())
                            history.push('/auth/login')
                        }
                    })
                    .catch((error: any) => {
                    })
            }
        } catch (err) {
            console.log('Fail refresh', err)
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            refresh()
        }, 5000);
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, [sessionId]);

    useEffect(() => {
        // readXML();
    }, []);

    const value = {
        refresh,
        currentStep,
        handleCurrentStep,
        currentIndex,
        handleCurrentIndex,
        maxIndex,
        handleMaxIndex,
        newCount,
        handleNewCount,
        showCompany,
        handleShowCompany,
        savingProcesses,
        setSavingProcesses,
        setGlobalHasChanged,
        changed,
        handleAddProcess,
        handleRemoveProcess,
        globalSaving,
        setGlobalSaving,
        requestSqlVersion,
        setRequestSqlVersion,
        applySqlUpdates,
        setApplySqlUpdates,
        applyAllScripts,
        setApplyAllScripts,
        erp,
        setErp,
        partner,
        setPartner,
        customer,
        setCustomer,
        cloud,
        setCloud,
        solo,
        setSolo,
        enterprise,
        setEnterprise,
        partnerCheck,
        setPartnerCheck,
        applingSystem,
        setApplingSystem,
        applingScriptName,
        setApplyingScriptName,
        requestXmlVersion,
        setRequestXmlVersion,
        applyXmlUpdates,
        setApplyXmlUpdates
    }
    return (
        <Context.Provider value={value} >
            {children}
        </Context.Provider>
    )
}
